import './AppToolbar.css'
import React from "react";
import {IonAvatar, IonButton, IonIcon, IonTitle, IonToolbar} from "@ionic/react";
import AuthenticationLocalService from "../../services/storage/localStorage/AuthenticationLocalService";
import {logOut} from "ionicons/icons";
import {Button, Menu, MenuItem, Tooltip} from "@mui/material";
import OperationLocalService from "../../services/storage/localStorage/OperationLocalService";
import SynchronizeButton from "./buttons/SynchronizeButton";
import {languages} from "../../lang/ELanguage";
import {ILanguage} from "../../lang/ILanguage";
import LanguageService from "../../services/storage/localStorage/LanguageService";
import i18n from "i18next";
import {withTranslation, WithTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    /**
     * Title displayed in the bar.
     */
    appTitle: string
}

/**
 * Component displaying a menu bar with a custom title.
 * @author Alizée Grand
 * @version 1.0
 * @creation 16/03/2022
 * @last_update 16/03/2022
 **/
class AppToolbar extends React.Component<Props, {
    anchor: null | HTMLElement,
    isLanguageMenuOpen: boolean
}> {

    constructor(props: Props) {
        super(props);
        this.state = {
            anchor: null,
            isLanguageMenuOpen: false
        };
    }

    render() {

        const onLanguageMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
            this.setState({anchor: event.currentTarget, isLanguageMenuOpen: true});
        }

        const onLanguageMenuClose = () => {
            this.setState({anchor: null, isLanguageMenuOpen: false});
        }

        const onMenuItemClick = (language: ILanguage) => {
            LanguageService.createCurrentLanguage(language.languageAbbreviation);
            i18n.changeLanguage(language.languageAbbreviation).catch(err => {console.log(err)});
        }

        const getCurrentLanguageIcon = () => {
            const abbreviation = LanguageService.getCurrentLanguage();
            let iconPath = "assets/icon/flag/french.png";
            if(abbreviation) {
                const language = LanguageService.getLanguage(abbreviation);
                iconPath = language.flagPath;
            }
            return iconPath;
        }

        return (
            <IonToolbar color="dark" id="mainToolbar">
                <IonTitle id="toolbarTitle">{this.props.appTitle}</IonTitle>
                <IonAvatar slot="start">
                    <img src="assets/illustration/logo/logo-fonroche-eclairage-02.png" alt="Fonroche logo"/>
                </IonAvatar>
                <Tooltip title={this.props.t("utils.header.tooltip.language")} slot="end" >
                    <Button onClick={onLanguageMenuClick}>
                        <img src={getCurrentLanguageIcon()} alt="Current flag"/>
                    </Button>
                </Tooltip>
                <Menu
                    open={this.state.isLanguageMenuOpen}
                    anchorEl={this.state.anchor}
                    onClose={onLanguageMenuClose}
                >
                    {
                        languages.map((language, index) => (
                            <MenuItem key={index} onClick={() => {onMenuItemClick(language)}}>
                                <img src={language.flagPath} alt={language.languageName}/>
                                &nbsp;{language.languageName}
                            </MenuItem>
                        ))
                    }
                </Menu>
                {
                    OperationLocalService.getOperationsBySync(false).length > 0 ? <SynchronizeButton synchronizeColor="secondary"/> : ""
                }
                <Tooltip title={this.props.t("utils.header.tooltip.logout")}>
                    <IonButton onClick={() => AuthenticationLocalService.logout()} size="small" slot="end" className="actionButton">
                        <IonIcon icon={logOut} slot="icon-only"/>
                    </IonButton>
                </Tooltip>
            </IonToolbar>
        );

    };

}

export default withTranslation()(AppToolbar);
